import {
    Container,
    Typography,
    Box,
    Stack,
} from "@mui/material";
import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Chart.js Bar Chart',
        },
    },
};


// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js';

// import { Bar } from 'react-chartjs-2';
// import faker from 'faker';
import { faker } from '@faker-js/faker';

import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";

export default function TestSimple() {
    const { t } = useTranslation();
    const [value, setValue] = React.useState(1234);

    React.useEffect(() => {
        setValue(1234);
    }, []);

    let lang = getLang();

    const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

    let data = labels.map(() => faker.datatype.number({ min: 0, max: 1000 }));

    const chartData = {
        labels,
        datasets: [
            {
                label: 'Dataset 1',
                data: data,
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            }
        ],
    };

    // setValue(1234);

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">Test React Chart</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                    <pre>Value: {value} </pre>
                </Box>

                <Bar options={options} data={chartData} />;
                <pre>
                    {JSON.stringify(data, null, 4)}
                </pre>
            </Stack>
        </Container>
    )
}
